module.exports = __webpack_public_path__ + "static/fighter-01-387c3ed680fd47170b84396342e1bfb2.png";